import styled from 'styled-components';

export const RadioButtonContainer = styled.div`
    display: flex;
`;